/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Комментарий к заявке в ПЛ.
 */
export interface LoyaltyRequestChangeDtoView { 
    /**
     * время обновления заявки.
     */
    changeDate?: string;
    /**
     * комментарий к обновлению.
     */
    changeText?: string;
    /**
     * ID автора комментария.
     */
    userId?: string;
}

